export const useCustomPage = () => {
  // 是活动自定义页面的点击
  const pages = getCurrentPages();
  const curPage = pages[pages.length - 1].route;
  const isCustomPage =
    curPage === 'pages/home/index' ||
    curPage === 'pages/subpack-main/activity/index' ||
    curPage === 'pages/classify/index';

  return {
    isCustomPage,
  };
};
